import { cx } from '@platform/core/lib/cx';
import type { IIconProps } from './IIconProps';
import { ICON_SPRITE_URL } from './iconSprite';

/**
 * Іконка Lucide за назвою (UIUX/foundations/icons): вбудований SVG 24×24 з <use> на self-hosted спрайт, колір — currentColor,
 * лінія 1.8 з круглими кінцями. Без title — декоративна (aria-hidden); іконкові кнопки підписує aria-label кнопки.
 */
export function Icon({ name, size = 16, strokeWidth = 1.8, filled = false, className, title }: IIconProps) {
  return (
    <svg className={cx('icon', className)} width={size} height={size} viewBox="0 0 24 24" fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"
      role={title ? 'img' : undefined} aria-hidden={title ? undefined : true}>
      {title && <title>{title}</title>}
      <use href={`${ICON_SPRITE_URL}#${name}`} />
    </svg>
  );
}
